import React from 'react';
import { connect } from 'react-redux';
import { DataSource } from '~/Api/DataSource';
import { ApplicationState } from '~/Store';

import resolveIsLicensed from './resolveIsLicensed';

// @ts-expect-error strange React.FC typing
const RenderFunction: React.FC<
	React.PropsWithChildren<{
		isLicenced: boolean;
		children: (isLicenced: boolean) => string | JSX.Element | null;
	}>
> = ({ children, isLicenced }) => {
	return children(isLicenced);
};

function mapStateToProps(
	state: ApplicationState,
	props: {
		dataSource: DataSource;
	}
): { isLicenced: boolean } {
	const isLicenced = Boolean(
		resolveIsLicensed(state.accessToken.accessToken, state.customerDatasourceLicences, props.dataSource.type)
	);

	return {
		isLicenced,
	};
}

export default connect(mapStateToProps)(RenderFunction);
